<template>
  <div 
    :class="containerClasses"
    @mouseleave="handleContainerLeave"
    data-navbar-element
  >
    <div 
      ref="containerRef" 
      :class="navbarClasses"
      data-navbar-element
    >
      <NavBarLogo :logo-props="logoProps" />
      
      <NavBarMenu
        :menu-items="currentMenuItems"
        :active-submenu="activeSubmenu"
        :menu-refs="menuRefs"
        @menu-click="handleMenuClick"
        @menu-hover="handleMenuHover"
        @menu-leave="handleMenuLeave"
      />
      
      <NavBarContactButton 
        :contact-action="contactAction"
        :contact-text="contactText"
      />
    </div>

    <div 
      v-if="activeSubmenu"
      :class="submenuClasses"
      :style="{ left: `${submenuPosition}px` }"
      data-navbar-element
    >
      <Submenu :items="getActiveSubmenuItems()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSubmenu } from '../hooks/useSubmenu'
import { getDefaultMenuItems } from '../data/defaultMenuItems'
import type { NavBarProps } from '../types/navigation'
import NavBarLogo from './NavBarLogo.vue'
import NavBarMenu from './NavBarMenu.vue'
import NavBarContactButton from './NavBarContactButton.vue'
import Submenu from './Submenu.vue'

interface Props {
  menuItems?: NavBarProps['menuItems']
  logoProps?: NavBarProps['logoProps']
  contactAction?: NavBarProps['contactAction']
  contactText?: NavBarProps['contactText']
}

const props = withDefaults(defineProps<Props>(), {
  menuItems: undefined,
  logoProps: undefined,
  contactAction: undefined,
  contactText: 'Nous Contacter'
})

const {
  activeSubmenu,
  submenuPosition,
  containerRef,
  menuRefs,
  handleMenuClick,
  handleMenuHover,
  handleMenuLeave,
  handleContainerLeave
} = useSubmenu()

const currentMenuItems = computed(() => 
  props.menuItems && props.menuItems.length > 0 
    ? props.menuItems 
    : getDefaultMenuItems()
)
const getActiveSubmenuItems = () => {
  const activeMenuItem = currentMenuItems.value.find(item => item.key === activeSubmenu.value)
  return activeMenuItem?.submenu || []
}

const containerClasses = computed(() => 
`h-full w-full max-w-[1440px] hidden laptop:flex 
flex-col items-center justify-center relative navbar-container`
)

const navbarClasses = computed(() => 
  'bg-white h-[90px] min-h-[90px] 4k-screen:min-h-[100px] w-[90%] flex flex-row items-center justify-between rounded-[15px] px-3'
)



const submenuClasses = computed(() => 
  'min-h-[90px] laptop:min-h-[100px] w-[30%] bg-white rounded-[10px] mt-2 shadow-lg transition-all duration-300 animate-in slide-in-from-top-2 absolute top-[93px] z-10 submenu-container'
)
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

